module.exports = __webpack_public_path__ + "img/telephone_blue.b5b6de90.svg";